export default __webpack_public_path__ + "static/l2-feature-img-1-75c7f4d3abae02cd59faea303d9920d2.png";